export class ChangePassword{
    constructor(
        public password: String = '',
        public NewPassword: String = '',
        public username: String = '',
        
    ){}
}